import myGoalService from "../services/mygoal.service";
import RestService from "../services/rest.service";


export const getKpiFormList = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/kpi/kpi_form`).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const getEvaluateCycleList = (type = null) => (dispatch) => {
  return new Promise((resolve, reject) => {
    let url = `app/kpi/evaluate/dropdown/cycle`
    if (type) url += '?type=' + type
    RestService.get(url).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const getGoalList = (serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    if (!serial || serial === "") serial = 1
    RestService.get(`app/admin/kpi/corporate-goal/list/${serial}`).then(
      (response) => {
        let data = response.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        dispatch({
          type: "SET_CORP_GOAL_LIST",
          payload: {}
        });
        reject()
      }
    );
  })
};

export const getGoalListV2 = (serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    if (!serial || serial === "") serial = 1
    RestService.get(`app/admin/kpi/corporate-goal/list-v2/${serial}`).then(
      (response) => {
        let data = response.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        dispatch({
          type: "SET_CORP_GOAL_LIST",
          payload: {}
        });
        reject()
      }
    );
  })
};

export const getGoalListByEvaluate = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/admin/kpi/corporate-goal/get/${id}`).then(
      (response) => {
        resolve(response);
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject(error);
      }
    );
  });
};


export const getGroupLibrary = (serial, search) => (dispatch) => {
  return new Promise((resolve, reject) => {
    var api = `app/admin/kpi/corporate-goal/goal-group/${serial}`;
    var searchConvert = search;
    if (searchConvert) {
      searchConvert = searchConvert.replace(/ /g, '%20');
      searchConvert = searchConvert.replace(/#/g, '%23')
    }
    if (search) {
      api += `?search=${searchConvert}`
    }
    RestService.get(api).then(
      (response) => {
        resolve(response.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const getGoalType = (cycle) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/admin/kpi/corporate-goal/dropdown/goal-type/${cycle}`).then(
      (response) => {
        resolve(response.data);
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject(error);
      }
    );
  });
};

export const getGroupCategory = (cycle) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/admin/kpi/corporate-goal/dropdown/goal-category/${cycle}`).then(
      (response) => {
        resolve(response.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const getScaleLevel = (cycle) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/admin/kpi/corporate-goal/dropdown/scale-level-list/${cycle}`).then(
      (response) => {
        resolve(response.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const getCustomForm = (cycle) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/admin/kpi/corporate-goal/dropdown/customForm?id=${cycle}`).then(
      (response) => {
        resolve(response.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const getDropdownMetric = () => (dispatch) => {
  return myGoalService.getDropdownMetric().then(
    (response) => {
      return Promise.resolve(response.data);
    }
  );
};

export const getDropdownUnit = () => (dispatch) => {
  return myGoalService.getDropdownUnit().then(
    (response) => {
      return Promise.resolve(response.data);
    }
  );
};

export const getCategoryWeight = (id, serial) => (dispatch) => {
  return myGoalService.getCategoryWeight(id, serial).then(
    (response) => {
      dispatch({
        type: "SET_CATEGORY_WEIGHT",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};
export const getLibraryList = (serial, perPage, currentPage, search, groupIn) => (dispatch) => {
  return new Promise((fnResolve, fnReject) => {
    var api = `app/admin/kpi/corporate-goal/goal-library/${serial}?perPage=${perPage}&currentPage=${currentPage}`;
    if (search) {
      api += `&search=${search}`
    }
    if (groupIn) {
      var joinGroup = groupIn.join(',');
      api += `&groupIn=${joinGroup}`
    }
    RestService.get(`${api}`).then(
      (response) => {
        fnResolve(response.data);
      },
      (response) => {
        fnReject(response);
      }
    );
  });
};
export const getMemberTeamList = () => (dispatch) => {
  return myGoalService.getMemberTeamList().then(
    (response) => {
      dispatch({
        type: "SET_MEMBER_TEAM_LIST",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};
export const getMemberList = (cycleSerial, options = {}) => (dispatch) => {
  let endPoint = `app/admin/kpi/corporate-goal/dropdown/goal-member-list?serial=${cycleSerial}`
  if (Object.keys(options).length > 0) {
    for (let key in options) endPoint += '&' + key + '=' + options[key]
  }

  return new Promise((fnResolve, fnReject) => {
    RestService.get(endPoint).then(
      (response) => {
        fnResolve(response.data);
      },
      (response) => {
        fnReject(response);
      }
    );
  });
};
export const getEvaluatorList = () => (dispatch) => {
  return myGoalService.getEvaluatorList().then(
    (response) => {
      dispatch({
        type: "SET_EVALUATOR_LIST",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};
export const getAlignmentList = (cycle) => (dispatch) => {
  return new Promise((fnResolve, fnReject) => {
    var api = `app/admin/kpi/corporate-goal/dropdown/goal-alignment?cycle=${cycle}`;
    RestService.get(`${api}`).then(
      (response) => {
        fnResolve(response.data);
      },
      (response) => {
        fnReject(response);
      }
    );
  });
};
export const getGoalAlignmentDetail = (serial) => (dispatch) => {
  return new Promise((fnResolve, fnReject) => {
    var api = `app/admin/kpi/corporate-goal/${serial}/alignment`;
    RestService.get(`${api}`).then(
      (response) => {
        fnResolve(response.data);
      },
      (response) => {
        fnReject(response);
      }
    );
  });
};
export const getGoalAlignmentChild = (serial) => (dispatch) => {
  return new Promise((fnResolve, fnReject) => {
    var api = `app/admin/kpi/corporate-goal/${serial}/child`;
    RestService.get(`${api}`).then(
      (response) => {
        fnResolve(response.data);
      },
      (response) => {
        fnReject(response);
      }
    );
  });
};
export const getMyGoalProgress = (serial) => (dispatch) => {
  return myGoalService.getMyGoalProgress(serial).then(
    (response) => {
      dispatch({
        type: "SET_MYGOAL_PROGRESS",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};
export const postCreateMyGoal = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/admin/kpi/corporate-goal/create`, data).then(
      (response) => {
        resolve(response);
      },
      (response) => {
        reject(response);
      }
    );
  });
}

export const putEditMyGoal = (serial, data) => (dispatch) => {
  return new Promise((fnResolve, fnReject) => {
    var api = `app/admin/kpi/corporate-goal/${serial}`;
    RestService.put(`${api}`, data).then(
      (response) => {
        fnResolve(response);
      },
      (response) => {
        fnReject(response);
      }
    );
  });
}

export const postAddMembers = (serial, data) => (dispatch) => {
  return new Promise((fnResolve, fnReject) => {
    var api = `app/admin/kpi/corporate-goal/${serial}/add-members`;
    RestService.post(`${api}`, data).then(
      (response) => {
        fnResolve(response.data);
      },
      (response) => {
        fnReject(response);
      }
    );
  });
}

export const deleteMember = (data) => (dispatch) => {
  return new Promise((fnResolve, fnReject) => {
    var api = `app/admin/kpi/corporate-goal/member/remove`;
    RestService.put(`${api}`, data).then(
      (response) => {
        fnResolve(response);
      },
      (response) => {
        fnReject(response);
      }
    );
  });
}

export const postCascadeGoal = (serial, data) => (dispatch) => {
  return new Promise((fnResolve, fnReject) => {
    var api = `app/admin/kpi/corporate-goal/${serial}/cascade-goal`;
    RestService.post(`${api}`, data).then(
      (response) => {
        fnResolve(response.data);
      },
      (response) => {
        fnReject(response);
      }
    );
  });
}

export const getMyGoalEditDetail = (serial) => (dispatch) => {
  return myGoalService.getMyGoalEditDetail(serial).then(
    (response) => {
      dispatch({
        type: "GET_MYGOAL_DETAIL",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
}
export const deleteGoal = (serial) => (dispatch) => {
  return new Promise((fnResolve, fnReject) => {
    var api = `app/admin/kpi/corporate-goal/${serial}`;
    RestService.delete(`${api}`).then(
      (response) => {
        fnResolve(response);
      },
      (response) => {
        fnReject(response);
      }
    );
  });
}
export const getGoalForEdit = (serial) => (dispatch) => {
  return new Promise((fnResolve, fnReject) => {
    var api = `app/admin/kpi/corporate-goal/${serial}`;
    RestService.get(`${api}`).then(
      (response) => {
        let resp = response?.data
        fnResolve(resp);
      },
      (response) => {
        fnReject(response);
      }
    );
  });
}
export const postSubmitApproval = (serial, data) => (dispatch) => {
  return myGoalService.postSubmitApproval(serial, data).then(
    (response) => {
      dispatch({
        type: "POST_SUBMIT_APPROVAL",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
}
export const putUpdateProgress = (serial, data) => (dispatch) => {
  return myGoalService.putUpdateProgress(serial, data).then(
    (response) => {
      dispatch({
        type: "UPDATE_PROGRESS",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
}
export const postUploadFile = (serial, file) => (dispatch) => {
  let data = new FormData();
  for (let index = 0; index <= file.length - 1; index++) {
    data.append("file", file[index]);
  }
  return new Promise((resolve, reject) => {
    RestService.posts(`app/kpi/goals/${serial}/files`, data).then(
      (response) => {
        let resp = response.data
        resolve(resp)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const getGoalFiles = (serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/kpi/goals/file/${serial}`).then(
      (response) => {
        console.log(response.data, 74155);
        let resp = response.data
        resolve(resp)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const getConfigUpload = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/config/upload/kpi_goal_file`).then(
      (response) => {
        resolve(response)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const deleteFileGoal = (serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.delete(`app/kpi/goals/file/${serial}`).then(
      (response) => {
        let resp = response.data
        resolve(resp)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const getFileDetail = (serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/kpi/achievement/file/${serial}`).then(
      (response) => {
        resolve(response)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const getCorporateGoalChart = (serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/admin/kpi/corporate-goal/chart/${serial}`).then(
      (response) => {
        resolve(response?.data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}